import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { mumulLiveService } from 'shared/src/api';
import { useIsMumulLiveExpTarget } from '../hooks/useIsMumulLiveExpTarget';

/**
 * 무물라이브 프로필 상태 조회.
 * 실험 대상(EXP1867 A/B군)이고 `profileSno`(market.mumul_live_profile_sno)가
 * 있을 때만 호출한다. 대조군(A)은 UI 노출 없이 CHECK_EXP_1867_TARGET 로깅용으로만 쓴다.
 */
export const useMumulLiveProfileStatus = (profileSno: number | null) => {
  const isExpTarget = useIsMumulLiveExpTarget();

  return useQuery({
    queryKey: queryKey.mumulLiveProfileStatus(profileSno ?? 0),
    queryFn: () =>
      mumulLiveService.getMumulLiveProfileStatus(profileSno as number),
    enabled: isExpTarget && profileSno != null,
  });
};
